import React, { useState, useEffect, useContext } from "react";
import { AdminSiteContext } from "../contexts/AdminSiteContext";
import { fetchAll } from "../utils/fetchResources";
import { useHistory, Prompt } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { onReadyCKE, CKEconfig } from "../config/CKE";
import SetFile from "../components/SetFile";
import {
	Typography,
	Switch,
	FormGroup,
	FormControl,
	InputLabel,
	Input,
	FormControlLabel,
	MenuItem,
	Select,
	Grid,
	Button,
	TextField,
	Hidden,
	Card,
	CardContent,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";

const useStyles = makeStyles((theme) => ({
	form: {
		width: "100%", // Fix IE 11 issue.
	},
	submit: {
		margin: theme.spacing(2, 0, 1),
	},
	chips: {
		display: "flex",
		flexWrap: "wrap",
	},
	chip: {
		margin: 2,
	},
}));

export default function PeopleAdd(props) {
	const classes = useStyles();
	const { adminSelectedSite, setAdminSelectedSite } = useContext(AdminSiteContext);
	const [newPerson, setNewPerson] = useState({
		relatedPeople: [],
		relatedEntries: [],
		published: false,
	});
	const [people, setPeople] = useState();
	const [entries, setEntries] = useState();
	const [filteredEntries, setFilteredEntries] = useState();
	const [sites, setSites] = useState();
	const [unsaved, setUnsaved] = useState(false);
	const { enqueueSnackbar } = useSnackbar();
	const history = useHistory();

	useEffect(() => {
		fetchAll("people", setPeople, "lastName");
		fetchAll("entries", setEntries, "title");
		fetchAll("sites", setSites, "name");
	}, []);

    useEffect(()=>{
        if(adminSelectedSite && entries){
            console.log(adminSelectedSite)
            const filtered = entries.filter(entry => entry.unit.site.id === adminSelectedSite._id);
            setFilteredEntries(filtered);
        }
    }, [adminSelectedSite, entries])

	const onChange = (e) => {
		setNewPerson({ ...newPerson, [e.target.name]: e.target.value });
		setUnsaved(true);
	};

	const onChangeBio = (e, editor) => {
		const data = editor.getData();
		setNewPerson({ ...newPerson, bio: data });
		setUnsaved(true);
	};

	const onChangeFileCitation = (e, editor) => {
		const data = editor.getData();
		setNewPerson({ ...newPerson, fileCitation: data });
		setUnsaved(true);
	};

	const onChangePublished = (event) => {
		setNewPerson({ ...newPerson, [event.target.name]: event.target.checked });
		setUnsaved(true);
	};

    const handleChangeSelectedSite = (e) => {
        setAdminSelectedSite(e.target.value)
    }

	const onSubmit = (e) => {
		e.preventDefault();

		//Remove any keys with an empty str as the value
		for (const key of Object.keys(newPerson)) {
			if (newPerson[key] === "") {
				delete newPerson[key];
			}
		}

		fetch(`${process.env.REACT_APP_API_URL}/people`, {
			method: "POST",
			credentials: "include",
			body: JSON.stringify(newPerson),
			headers: { "Content-Type": "application/json" },
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.success) {
					setUnsaved(false);
					enqueueSnackbar("Person added successfully!", { variant: "success" });
					history.push(`/${process.env.REACT_APP_ADMIN_URL}/people`);
				} else {
					console.log(data);
					const errorArray = data.error.split(",");
					errorArray.forEach((error) => {
						enqueueSnackbar(`${error}`, { variant: "error" });
					});
				}
			});
	};

	if (!entries && !people && !sites) {
		return <>Loading...</>;
	}

	return (
		<>
			<Prompt
				when={unsaved}
				message="You have unsaved changes. Are you sure you want to leave?"
			/>
			<Typography component="h1" variant="h4">
				Add a Person
			</Typography>
			<Grid container spacing={2}>
				<Grid item xs={12} sm={12} md={9}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={12} md={4}>
							<TextField
								variant="outlined"
								margin="normal"
								fullWidth
								id="firstName"
								label="First Name"
								required
								name="firstName"
								size="small"
								autoFocus
								onChange={onChange}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={4}>
							<TextField
								variant="outlined"
								margin="normal"
								fullWidth
								id="middleName"
								label="Middle Name"
								name="middleName"
								size="small"
								onChange={onChange}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={4}>
							<TextField
								variant="outlined"
								margin="normal"
								fullWidth
								id="lastName"
								label="Last Name"
								name="lastName"
								size="small"
								onChange={onChange}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={6}>
							<TextField
								variant="outlined"
								margin="normal"
								fullWidth
								id="suffix"
								label="Suffix"
								name="suffix"
								size="small"
								onChange={onChange}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={6}>
							<TextField
								variant="outlined"
								margin="normal"
								fullWidth
								id="title"
								label="Title"
								name="title"
								size="small"
								onChange={onChange}
							/>
						</Grid>
					</Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12}>
							<FormControl
								fullWidth
								className={classes.formControl}
								size="medium"
								margin="normal"
							>
								<InputLabel id="siteLabel">Site</InputLabel>
								<Select
									inputProps={{ name: "site" }}
									labelId="site"
									id="site"
									value={adminSelectedSite ?? ""}
									onChange={handleChangeSelectedSite}
                                    autoWidth
                                    required
								>
								<MenuItem value="">All Sites</MenuItem>
							{ sites &&
								sites.map((site, i) => (
									<MenuItem key={i} value={site}>
										{site.name}
									</MenuItem>
								))}

								</Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    { adminSelectedSite && filteredEntries &&
					<Grid container spacing={2}>
						<Grid item xs={12} sm={12} md={6}>
							<FormControl
								fullWidth
								className={classes.formControl}
								size="medium"
								margin="normal"
							>
								<InputLabel id="relatedPeopleLabel">Related People</InputLabel>
								<Select
									inputProps={{ name: "relatedPeople" }}
									labelId="relatedPeople"
									id="relatedPeople"
									multiple
									value={newPerson.relatedPeople}
									onChange={onChange}
									input={<Input />}
									renderValue={() => "View Selected"}
								>
									{people &&
										 people.map((person) => {
											let name = "";
											if (person.firstName) {
												name += person.firstName;
											}
											if (person.middleName) {
												name += " " + person.middleName;
											}
											if (person.lastName) {
												name += " " + person.lastName;
											}
											if (person.suffix) {
												name += " " + person.suffix;
											}
											if (person.title) {
												name += ", " + person.title;
											}
											return (
												<MenuItem key={person._id} value={person._id}>
													{name}
												</MenuItem>
											);
										})}
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={12} md={6}>
							<FormControl
								fullWidth
								className={classes.formControl}
								size="medium"
								margin="normal"
							>
								<InputLabel id="relatedEntriesLabel">
									Related Entries
								</InputLabel>
								<Select
									inputProps={{ name: "relatedEntries" }}
									labelId="relatedEntries"
									id="relatedEntries"
									multiple
									value={newPerson.relatedEntries}
									onChange={onChange}
									disabled={filteredEntries.length === 0}
									renderValue={() => "View Selected"}
								>
									{sites &&
										filteredEntries &&
										sites.map((site) =>
											filteredEntries
												.filter((entry) => entry.unit.site._id === site._id)
												.map((entry) => (
													<MenuItem key={entry._id} value={entry._id}>
														<Typography
															style={{ fontWeight: "bold" }}
														>{`${site.name}: `}</Typography>
														<Typography
															style={{ marginLeft: ".25rem" }}
														>{`${entry.title}`}</Typography>
													</MenuItem>
												))
										)}
								</Select>
							</FormControl>
						</Grid>
					</Grid>
                    }
					<Grid container spacing={2}>
						{/*TODO: Add options for approximate dates, like only knowing the month or year, or even approximate year*/}
						<Grid item xs={12} sm={12} md={6}>
							<TextField
								variant="outlined"
								margin="normal"
								fullWidth
								name="dob"
								label="Date of Birth"
								type="string"
								size="small"
								onChange={onChange}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={6}>
							<TextField
								variant="outlined"
								margin="normal"
								fullWidth
								name="dod"
								label="Date of Death"
								type="string"
								size="small"
								onChange={onChange}
							/>
						</Grid>
					</Grid>
					<Typography style={{ marginTop: "1.5rem", fontWeight: "bold" }}>
						Biography:
					</Typography>
					<CKEditor
						onReady={(editor) => {
							onReadyCKE(editor);
						}}
						editor={Editor}
						onChange={onChangeBio}
						config={CKEconfig("Person's biography...")}
					/>
					<Typography style={{ marginTop: "1.5rem", fontWeight: "bold" }}>
						File Citation:
					</Typography>
					<CKEditor
						onReady={(editor) => {
							onReadyCKE(editor);
						}}
						editor={Editor}
						onChange={onChangeFileCitation}
						config={CKEconfig("File citation...")}
					/>
					<Button
						type="submit"
						onClick={onSubmit}
						fullWidth
						variant="contained"
						color="primary"
						className={classes.submit}
					>
						Save
					</Button>
				</Grid>
				<Grid item xs={12} sm={12} md={3}>
					<Card>
						<CardContent>
							<Hidden smDown>
								<Button
									type="submit"
									onClick={onSubmit}
									fullWidth
									variant="contained"
									color="primary"
									className={classes.submit}
								>
									Save
								</Button>
							</Hidden>
							<FormGroup row>
								<FormControlLabel
									control={
										<Switch
											color="primary"
											checked={newPerson.published}
											onChange={onChangePublished}
											name="published"
										/>
									}
									label={
										newPerson.published ? (
											<Typography color="primary">Published</Typography>
										) : (
											<Typography color="secondary">Draft</Typography>
										)
									}
								/>
							</FormGroup>
							<SetFile
								fileTitle="Featured Image"
								resource={newPerson}
								setResource={setNewPerson}
								imageOnly={true}
								fileLabel="featuredImage"
								fileLabelFileName="featuredImageFile"
							/>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
		</>
	);
}
